/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { externalKeysListGcpKms } from "../funcs/externalKeysListGcpKms.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListExternalKeysResult } from "../models/components/listexternalkeysresult.js";
import {
  ListGcpKmsKeysRequest,
  ListGcpKmsKeysSecurity,
} from "../models/operations/listgcpkmskeys.js";
import { unwrapAsync } from "../types/fp.js";
export type ListGcpKmsKeysQueryData = ListExternalKeysResult;

export function prefetchListGcpKmsKeys(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListGcpKmsKeysRequest | undefined,
  security?: ListGcpKmsKeysSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListGcpKmsKeysQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListGcpKmsKeysQuery(
  client$: GramCore,
  request?: ListGcpKmsKeysRequest | undefined,
  security?: ListGcpKmsKeysSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<ListGcpKmsKeysQueryData>;
} {
  return {
    queryKey: queryKeyListGcpKmsKeys({ gramSession: request?.gramSession }),
    queryFn: async function listGcpKmsKeysQueryFn(
      ctx,
    ): Promise<ListGcpKmsKeysQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(externalKeysListGcpKms(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListGcpKmsKeys(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "externalKeys", "listGcpKms", parameters];
}
